/**
 * Viewer 集成点渲染：当宿主需要「用某插件预览当前条目」时，根据 manifest 的 `viewer` 配置解析 iframe URL，
 * 并通过 `extraInitPayload` 将 `item` 传给插件 init，供插件内展示与当前资源一致的内容。
 */
import { PluginIframe } from "./plugin-iframe";
import { usePluginManager } from "./plugin-manager-context";

interface ViewerRendererProps {
  pluginId: string;
  /** 当前被预览的数据对象（URL、标题等）；会随 key 变化触发 iframe 重挂载 */
  item: {
    id: string;
    url: string;
    title: string;
    format?: string;
    [key: string]: unknown;
  };
  className?: string;
  style?: React.CSSProperties;
}

export function ViewerRenderer({
  pluginId,
  item,
  className,
  style,
}: ViewerRendererProps) {
  const manager = usePluginManager();
  if (!manager) return null;

  const manifest = manager.getManifest(pluginId);
  const baseUrl = manager.getBaseUrl(pluginId);
  if (!manifest?.viewer || !baseUrl) return null;

  const src = manager.resolveUrl(baseUrl, manifest.viewer.path);

  return (
    <PluginIframe
      key={`${pluginId}-${item.id}`}
      pluginId={pluginId}
      src={src}
      className={className}
      style={style}
      extraInitPayload={{ item }}
    />
  );
}
